'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/pow.js
// module id = 2209
// module chunks = 41